import React from 'react';
import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Title } from '@/components/ui/Headings';

interface InclusionsSectionProps {
  includes: string[];
  notIncluded: string[];
}

export default function InclusionsSection({ includes, notIncluded }: InclusionsSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div>
        <Title size="sm" className="mb-4">{t('travelThemes.included')}</Title>
        <ul className="space-y-2">
          {includes.map((item, index) => (
            <li key={index} className="flex items-center space-x-2">
              <Check className="h-4 w-4 text-green-600 flex-shrink-0" />
              <span className="text-sm text-gray-600">{item}</span>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <Title size="sm" className="mb-4">{t('travelThemes.notIncluded')}</Title>
        <ul className="space-y-2">
          {notIncluded.map((item, index) => (
            <li key={index} className="flex items-center space-x-2">
              <X className="h-4 w-4 text-gray-400 flex-shrink-0" />
              <span className="text-sm text-gray-600">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
